const secondInMilliseconds = 1000;
const minuteInSeconds = 60;
const hourInSeconds = 60 * minuteInSeconds;
const dayInSeconds = 24 * hourInSeconds;
const dayInMilliseconds = secondInMilliseconds * dayInSeconds;
const minuteInMilliseconds = secondInMilliseconds * minuteInSeconds;
const weekInSeconds = 7 * dayInSeconds;
const yearInSeconds = 52 * weekInSeconds;

/**
 * @param {number} milliseconds
 * @returns {string}
 */
function millisecondsToHumanReadableDuration(milliseconds) {
	const seconds = Math.ceil(milliseconds / secondInMilliseconds);

	if (seconds < 60) {
		return `${seconds} seconds`;
	}

	const minutes = Math.ceil(seconds / minuteInSeconds);

	if (minutes < 60) {
		return `${minutes} minutes`;
	}

	const hours = Math.ceil(minutes / 60);

	if (hours < 24) {
		return `${hours} hours`;
	}

	return `${Math.ceil(milliseconds / 24)} days`;
}


module.exports = {
	dayInMilliseconds,
	dayInSeconds,
	hourInSeconds,
	millisecondsToHumanReadableDuration,
	minuteInMilliseconds,
	minuteInSeconds,
	secondInMilliseconds,
	weekInSeconds,
	yearInSeconds,
};
